import Privacy from 'pages/privacy';
import Button from 'components/partials/Fields/Button';
import { Col, Row } from 'react-bootstrap';
import FormTools from '../../partials/Fields/FormTools';
import { useService } from 'hooks/useService';
import { PUT } from 'services/RequestMethods';
import { general_error_toastr } from 'components/partials/Notification';
import { APP_CONFIG } from 'Config';
import { useLoginContext } from 'components/Login/_context/useLoginContext';

export const PrivacyPolicy = () => {
    const [{}, fireAgree] = useService({ url: '/users/account/agreed/privacy', method: PUT });
    const { runChecksAndLogin } = useLoginContext();

    const handleSubmit = async () => {
        try {
            await fireAgree();
            await runChecksAndLogin();
        } catch (e) {
            general_error_toastr();
        }
    };

    return (
        <Row>
            <Col style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <h2 className="section-title marginB30">
                    Privacy Policy Agreement
                </h2>
                <div className="unavailable-message">
                    On {APP_CONFIG.REACT_APP_DATE_PRIVACY}, StorageTreasures updated its Privacy Policy. Please review
                    it below.
                </div>
                <Privacy/>
                <form
                    id="accept-privacy"
                    onSubmit={e => e.preventDefault()}
                >
                    <FormTools
                        formID="accept-privacy"
                        onSubmit={handleSubmit}
                    />
                    <Button
                        type="submit"
                        label="I accept and agree"
                        className="btn btn-blue btn-regular marginT15"
                    />
                </form>
            </Col>
        </Row>
    );
};
